import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer: React.FC = () => {
  const location = useLocation();
  const isPrivacyPage = location.pathname === '/privacy';
  
  // Use different styling for privacy page to allow scrolling
  const footerClasses = isPrivacyPage
    ? "py-4 px-6 z-20 backdrop-blur-sm relative mt-auto" // Static position for privacy page
    : "py-4 px-6 fixed bottom-0 left-0 right-0 z-20 backdrop-blur-sm"; // Fixed position for main page
  
  return (
    <footer className={footerClasses}>
      <div className="max-w-6xl mx-auto text-center">
        <div className="text-white text-xs flex justify-center items-center space-x-4">
          <span className="opacity-70">© {new Date().getFullYear()} Quote Vibes Daily by Kanto Projects.</span>
          <Link
            to="/privacy"
            className="opacity-70 hover:opacity-100 hover:underline transition-opacity"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 